import map from "lodash/fp/map";

class ResetFields {
  constructor() {
    this.reset = map((field) => {
      if (/_i18n$/.test(field.name)) {
        // Regex over endswith to support old browsers
        field.i18n = { en: "", ar: "" };
      }
      field.value = null;
      field.items = [];

      return field;
    });
  }
}

export default ResetFields;



// WEBPACK FOOTER //
// ./src/services/resetFields/resetFields.service.js